function number2DateTime (value, fmt = 'yyyy-MM-dd HH:mm:ss') { // yyyy-MM-dd HH:mm:ss
  if (isNaN(value)) return ''
  const date = new Date(Number(value))
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return fmt.replace('yyyy', year.toString())
    .replace('yy', (year % 100).toString())
    .replace('MM', month > 9 ? month.toString() : ('0' + month))
    .replace('dd', day > 9 ? day.toString() : ('0' + day))
    .replace('HH', hour > 9 ? (hour).toString() : ('0' + hour))
    .replace('mm', minute > 9 ? (minute).toString() : ('0' + minute))
    .replace('ss', second > 9 ? (second).toString() : ('0' + second))
}

export default {
  number2DateTime
}



// WEBPACK FOOTER //
// ./src/js/filters/momentTime.js